import {
  Box,
  Button,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
} from '@material-ui/core'
import { mdiAlertCircleOutline } from '@mdi/js'
import Icon from '@mdi/react'
import moment from 'moment-timezone'
import React from 'react'
import { Link } from 'react-router-dom'

import colors from '../../../../assets/colors'
import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'

const useStyles = makeStyles({
  content: {
    color: colors.primary,
  },
  divider: {
    height: '1px',
    backgroundColor: colors.graylight,
    margin: '12px 0',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  label: {
    color: colors.textPrimary,
    fontSize: '14px',
  },
  value: {
    color: colors.primary,
    fontSize: '14px',
    fontWeight: 700,
  },
  badge: {
    backgroundColor: colors.bgInfo,
    color: colors.info,
    fontSize: '12px',
    fontWeight: 700,
    padding: '4px 10px',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
  },
  progress: {
    height: 6,
    borderRadius: 4,
    backgroundColor: colors.graylight,
    marginTop: 8,
  },
  progressBar: {
    borderRadius: 4,
    backgroundColor: colors.secondary,
  },
  pendingLabel: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 6,
    color: colors.error,
    fontSize: '14px',
    fontWeight: 600,
    '& svg': {
      flexShrink: 0,
    },
  },
  manageButton: {
    width: '100%',
    marginTop: 16,
    backgroundColor: colors.primary,
    color: '#FFF',
    borderRadius: '10px',
    padding: '10px',
    fontWeight: 700,
    textTransform: 'none',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: 0.85,
    },
  },
})

const LaundrySubscriptionStatus = ({
  open = false,
  handleOpen = () => {},
  status = {},
  isOk = true,
}) => {
  const classes = useStyles()

  const {
    laundry_status_label: statusLabel,
    trial_expiration_date: expiresAt,
    trial_days_to_expire: daysToExpire,
    trial_days: daysTotal,
    subscription_status_value: pendingMessage,
  } = status

  const remaining = Number(daysToExpire) || 0
  const total = Number(daysTotal) || 0
  const elapsed = Math.max(total - remaining, 0)
  const progress = total > 0 ? Math.min((elapsed / total) * 100, 100) : 0

  return (
    <BaseFilterModal
      open={open}
      handleOpen={handleOpen}
      title="Assinatura"
      hiddenHelpButton
    >
      <Grid item xs={12}>
        <Box className={classes.content}>
          {statusLabel && (
            <>
              <Box className={classes.row}>
                <Typography className={classes.label}>Status</Typography>
                <Typography component="span" className={classes.badge}>
                  {statusLabel}
                </Typography>
              </Box>
            </>
          )}

          {expiresAt && (
            <>
              <Box className={classes.divider} />
              <Box className={classes.row}>
                <Typography className={classes.label}>Termina em</Typography>
                <Typography className={classes.value}>
                  {moment(expiresAt).format('DD/MM/YYYY')}
                </Typography>
              </Box>
            </>
          )}

          {total > 0 && (
            <>
              <Box className={classes.divider} />
              <Box className={classes.row}>
                <Typography className={classes.label}>
                  Tempo restante
                </Typography>
                <Typography className={classes.value}>
                  {elapsed} de {total} dias
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={progress}
                classes={{
                  root: classes.progress,
                  bar: classes.progressBar,
                }}
              />
            </>
          )}

          {isOk && pendingMessage && (
            <>
              <Box className={classes.divider} />
              <Typography component="div" className={classes.pendingLabel}>
                <Icon path={mdiAlertCircleOutline} size={0.8} />
                {pendingMessage}
              </Typography>
            </>
          )}

          <Button
            component={Link}
            to="/subscription"
            onClick={handleOpen}
            className={classes.manageButton}
          >
            Gerenciar assinatura
          </Button>
        </Box>
      </Grid>
    </BaseFilterModal>
  )
}

export default LaundrySubscriptionStatus
